import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Box, FormControl, FormLabel, FormGroup, FilledInput, TextField, Divider, Tab, Tabs, AppBar, IconButton, Icon, Collapse, Button, Radio, RadioGroup, FormControlLabel, InputAdornment, Tooltip, Switch } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { DataGrid } from '@material-ui/data-grid';
import { useLocation } from 'react-router-dom';
import ReactExport from "react-data-export";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import PropTypes from 'prop-types';

import Loader from '../../common/loader';
import Crud from '../../common/crud';
import DateRange from '../../common/date-range';

import AuthContext from '../../context';
import { del, get, post, put } from '../../utils/api-services';
import helpers from '../../utils/helpers';
dayjs.extend(utc);
dayjs.extend(timezone);

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const useStyles = makeStyles(() => ({
    divider: {
        marginBottom: 24
    },
    tableContainer: {
        width: '100%',
        marginTop: 20
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    buttonsContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
        marginBottom: 20
    },
    search: {
        marginLeft: 15,
        backgroundColor: '#198754',
        borderColor: '#198754',
        '&:hover': {
            backgroundColor: '#198754',
            borderColor: '#198754',
            boxShadow: 'none',
        },
    },
    report: {
        marginLeft: 15,
        backgroundColor: '#0d6efd',
        borderColor: '#0d6efd',
        '&:hover': {
            backgroundColor: '#0d6efd',
            borderColor: '#0d6efd',
            boxShadow: 'none',
        },
    },
    wrapText: {
        "&>.MuiAlert-message": {
            whiteSpace: "pre-wrap",
        },
    },
    requiredValue: {
        fontWeight: "600",
        color: "rgba(255,0,0,1)",
    },
    download: {
        marginLeft: 15,
        backgroundColor: "#6E6E6E",
        borderColor: "#6E6E6E",
        "&:hover": {
            backgroundColor: "#6E6E6E",
            borderColor: "#6E6E6E",
            boxShadow: "none",
        },
    },
    upload: {
        backgroundColor: "#6E6E6E",
        borderColor: "#6E6E6E",
        "&:hover": {
            backgroundColor: "#6E6E6E",
            borderColor: "#6E6E6E",
            boxShadow: "none",
        },
    },
    switch: {
        marginRight: 8,
        marginLeft: 10,
        '& .MuiSwitch-track': {
            opacity: 1,
            backgroundColor: '#aab4be',
        }
    }
}));

//Functions for tabs
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ bgcolor: 'rgba(0, 0, 0, 0.1)' }} p={2}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
//------------------------------------

const ScannerPaylocityDesktop = () => {
    const sede = JSON.parse(window.localStorage.getItem('@sede'));
    const defaultState = {
        idpaylocity_scanner: 0,
        employee: { id: 0, name: "Choose an employee" },
        cost_center: { id: 0, name: "Choose a cost center" },
        cost_center_2: { id: 0, name: "Choose a cost center 2" },
        cost_center_3: { id: 0, name: "Choose a cost center 3" },
        action: { id: 0, name: "Choose an action" },
        date: dayjs().format('YYYY-MM-DD'),
        time: dayjs().tz(sede.time_zone).format('HH:mm'),
        clock_type: ''
    }

    const defaultFilter = {
        startDate: dayjs().subtract(1, 'day').format('YYYY-MM-DD'),
        endDate: dayjs().format('YYYY-MM-DD'),
        dateRange: `${dayjs().subtract(1, 'day').format('MM/DD/YYYY')} - ${dayjs().format('MM/DD/YYYY')}`,
        employeef: { id: 0, name: "All employees" },
        costCenter2f: { id: 0, name: "All cost center 2" },
        costCenter3f: { id: 0, name: "All cost center 3" },
        actionf: { id: 0, name: "All actions" },
    }

    const defaultDateRange = {
        open: false,
        range: [
            {
                startDate: new Date(dayjs().subtract(1, 'day')),
                endDate: new Date(),
                key: 'main'
            }
        ]
    }
    const { showToast, signOut, showLoader } = useContext(AuthContext);
    const classes = useStyles();
    const { pathname } = useLocation();
    const [showFilters, setShowFilters] = useState(true);
    const [tabValue, setTabValue] = useState(0);
    const [showErrorReport, setShowErrorReport] = useState(false);
    //EditTable
    const [initialRow, setInitialRow] = useState({})

    const [state, setState] = useState({
        loading: true,
        employees: [],
        costCenter1: [],
        costCenter2: [],
        costCenter3: [],
        selectionData: { cc1: [], cc2: [], cc3: [], action: [] },
        actions: [],
        scans: [],
        reportScans: [],
        filteredReportScans: [],
        reportError: 0,
        selectedScanRows: [],
        scan: {
            ...defaultState,
        },
        filter: {
            ...defaultFilter
        },
        rangeModal: {
            ...defaultDateRange
        },
        permissions: {}
    });

    useEffect(() => {
        validatePermissions();
    }, []);

    useEffect(() => {
        let filtered = state.reportScans.filter(i => !i.stop_time)
        setState(prev => ({ ...prev, reportError: filtered.length }))
        if (showErrorReport) {
            setState(prev => ({ ...prev, filteredReportScans: filtered }))
        } else {
            setState(prev => ({ ...prev, filteredReportScans: state.reportScans }))
        }
    }, [state.reportScans, showErrorReport])

    const validatePermissions = () => {
        const permissions = helpers.getPermissions(pathname);
        setState(prev => ({ ...prev, permissions }));

        (permissions.read_attr) ? makeRequest() : setState(prev => ({ ...prev, loading: false }));
    }

    const makeRequest = async () => {
        showLoader(true);
        const response = await get('/paylocityScanner', state.filter);
        if (response.status === 200) {
            setState(prev => ({
                ...prev,
                loading: false,
                scans: response?.data ?? [],
                reportScans: response?.reportData ?? [],
                employees: response?.employees ?? [],
                costCenter1: response?.costCenter1 ?? [],
                costCenter2: response?.costCenter2 ?? [],
                costCenter3: response?.costCenter3 ?? [],
                actions: prev.actions.concat(response?.actions ?? []),
                selectionData: response?.selectionData ?? { cc1: [], cc2: [], cc3: [], action: [] },
            }));
        } else {
            console.log('[Paylocity Scanner] makeRequest error', response);
            helpers.failRequest(response, showToast, signOut)
        }
        showLoader(false);
    }

    const handleChange = ({ target }) => { setState(prev => ({ ...prev, scan: { ...prev.scan, [target.name]: target.value } })) };

    const handleAutocomplete = (key, value) => {
        if (!value) {
            let nKey = key === 'cost_center_2' ? "costCenter2" : `${key}s`;
            nKey = nKey === 'cost_center_3s' ? "costCenter3" : nKey;
            setState(prev => ({ ...prev, scan: { ...prev.scan, [key]: state[nKey][0] } }));
        } else {
            if (key === 'employee') {
                let cost_center_2 = value.cc2 ? { id: value?.cc2?.id, name: value?.cc2?.name ?? value?.cc2?.code } : state.costCenter2[0];
                let cost_center_3 = value.cc3 ? { id: value?.cc3?.id, name: value?.cc3?.name ?? value?.cc3?.code } : state.costCenter3[0];

                setState(prev => ({ ...prev, scan: { ...prev.scan, cost_center_2, cost_center_3 } }));
            }
            setState(prev => ({ ...prev, scan: { ...prev.scan, [key]: value } }));
        }
    };

    const handleSwitchChange = (event) => {
        setShowErrorReport(event.target.checked);
    };

    const handleAutocompleteFilter = (key, value) => {
        if (!value) {
            let nKey = key.slice(0, -1) === 'costCenter2' ? "costCenter2" : `${key.slice(0, -1)}s`
            nKey = key.slice(0, -1) === 'costCenter3' ? "costCenter3" : nKey;
            setState(prev => ({ ...prev, filter: { ...prev.filter, [key]: state[nKey][0] } }));
        } else {
            setState(prev => ({ ...prev, filter: { ...prev.filter, [key]: value } }));
        }
    }

    const handleModal = () => setState(prev => ({ ...prev, rangeModal: { ...prev.rangeModal, open: !prev.rangeModal.open } }));

    const handleDateChange = item => {
        const { startDate, endDate } = item.main;
        const dateRange = `${dayjs(startDate.toISOString()).format('MM/DD/YYYY')} - ${dayjs(endDate.toISOString()).format('MM/DD/YYYY')}`;
        setState(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                dateRange,
                startDate: dayjs(startDate.toISOString()).format('YYYY-MM-DD'),
                endDate: dayjs(endDate.toISOString()).format('YYYY-MM-DD')
            },
            rangeModal: { ...prev.rangeModal, range: [item.main] }
        }));
    }

    const handleSelectionRows = (ids) => { setState((prev) => ({ ...prev, selectedScanRows: ids })); }

    //EditReportTable

    const handleStartEdit = ({ row }) => {
        setInitialRow(row)
    };

    const handleCommitEdit = ({ field, value }) => {
        //If on edit left value empty
        if (!value) {
            setState((prev) => ({ ...prev, filteredReportScans: state.filteredReportScans }));
            return
        };

        //If value is a date then format
        value = field === 'start' || field === 'stop' ? dayjs(value).format('YYYY-MM-DDHH:mm:ss') : value

        //Check if value was updated
        if (initialRow[field] === value) {
            setState((prev) => ({ ...prev, filteredReportScans: state.filteredReportScans }));
            return
        };

        const scan = {
            idpaylocity_scanner: field === 'stop' ? initialRow.idOut : initialRow.idIn,
            employee: initialRow.employee,
            cost_center: field === 'cc1' ? state.costCenter1.filter((r) => r.code === value)[0] : initialRow.cost_center,
            cost_center_2: field === 'cc2' ? state.costCenter2.filter((r) => r.code === value)[0] : initialRow.cost_center_2,
            cost_center_3: field === 'cc3' ? state.costCenter3.filter((r) => r.code === value)[0] : initialRow.cost_center_3,
            action: field === 'action' ? state.actions.filter((r) => r.name === value)[0] : initialRow.employee_hour_action,
            date: field === 'start' || field === 'stop' ? dayjs(value).format('YYYY-MM-DD') : initialRow.start_date,
            time: field === 'start' || field === 'stop' ? dayjs(value).format('HH:mm:ss') : initialRow.start_time,
            clock_type: field === 'stop' ? 'Out' : 'In',
            isTableUpdate: true
        }

        //If stop date and time are updated, if is empty it creates the new scan, else, is just updated
        if (field === 'stop') {
            if (initialRow.stop) {
                if (!update(initialRow.idOut, scan)) {
                    setState((prev) => ({ ...prev, filteredReportScans: this.filteredReportScans }));
                }
            } else {
                if (!store(scan)) {
                    setState((prev) => ({ ...prev, filteredReportScans: this.filteredReportScans }));
                }
            }
        } else {
            if (!update(initialRow.idIn, scan)) {
                setState((prev) => ({ ...prev, filteredReportScans: this.filteredReportScans }));
            }
        }

        setInitialRow({})
    }

    //--End editReportTable---------

    const validateForm = (option, scan) => {
        const { idpaylocity_scanner, employee, cost_center, cost_center_2, cost_center_3, action, date, time, clock_type, isTableUpdate } = scan;
        let issues = 0;
        let msg = "";

        if (!employee?.id || employee.id === 0) {
            issues += 1;
            msg += "Employee can't be empty\n";
        }
        if ((!employee?.cc1 || employee?.cc1?.id === 0) && (!cost_center?.id || cost_center?.id === 0)) {
            issues += 1;
            msg += "Employee does not have an associated Cost Center 1\n";
        }
        if (!cost_center_2?.id || cost_center_2.id === 0) {
            issues += 1;
            msg += "Cost Center 2 can't be empty\n";
        }
        if (!cost_center_3?.id || cost_center_3.id === 0) {
            issues += 1;
            msg += "Cost Center 3 can't be empty\n";
        }
        if (!action?.id || action.id === 0) {
            issues += 1;
            msg += "Action can't be empty\n";
        }
        if (!date) {
            issues += 1;
            msg += "Date can't be empty\n";
        }
        if (!time) {
            issues += 1;
            msg += "Time can't be empty\n";
        }
        if (!clock_type) {
            issues += 1;
            msg += "Clock type can't be empty\n";
        }

        switch (option) {
            case 'update':
                const data = state.scans.filter(value => value.idpaylocity_scanner === idpaylocity_scanner);
                if (isTableUpdate) {
                    if (issues > 0) {
                        showToast(msg, "error", 4000, classes.wrapText);
                        return false;
                    } else {
                        return true;
                    };
                }
                if (data[0]) {
                    const before = JSON.stringify(data[0]);
                    const after = JSON.stringify(scan);
                    if (before !== after) {
                        if (issues > 0) {
                            showToast(msg, "error", 4000, classes.wrapText);
                            return false;
                        } else {
                            return true;
                        };
                    } else {
                        showToast('Update some field', 'error');
                        return false;
                    }
                } else {
                    showToast('Select some scan', 'error');
                    return false;
                }

            case 'store':

                if (issues > 0) {
                    showToast(msg, "error", 4000, classes.wrapText);
                    return false;
                } else {
                    return true;
                };

            case 'delete':
                if (idpaylocity_scanner === 0) {
                    showToast('Select some scan', 'error');
                    return false;
                }
                const cond = window.confirm('Are you sure you want to delete this block (In and Out)?');

                return Boolean(idpaylocity_scanner && cond);

            default:
                return false;
        }
    }

    const clear = () => {
        setState(prev => ({ ...prev, scan: { ...defaultState, start_time: dayjs().tz(sede.time_zone).format('HH:mm'), end_time: dayjs().tz(sede.time_zone).format('HH:mm'), } }));
    }

    const clearFilters = () => {
        setState(prev => ({ ...prev, filter: defaultFilter }));
    }

    const uploadPaylocitydata = async () => {
        if (state.selectedScanRows === 0) {
            showToast("Select any scan data to upload", "error")
            return
        }
        showLoader(true);
        const response = await post("/paylocityScanner/paylocityUpload", { idRows: state.selectedScanRows, startDate: state.filter.startDate, endDate: state.filter.endDate });
        if (response.status === 200) {
            let tempScans = state.scans
            if (response.updateAll) {
                tempScans = tempScans.map(i => {
                    if (state.selectedScanRows.includes(i.idpaylocity_scanner)) {
                        return { ...i, uploaded: true, warning: false }
                    } else {
                        return i;
                    }
                })
            }
            setState(prev => ({ ...prev, selectedScanRows: [], scans: [] }))
            setState(prev => ({ ...prev, scans: tempScans }))
            showToast(response.message)
        } else {
            console.log("[ScanerPaylocityDesktop] upload error", response);
            helpers.failRequest(response, showToast, signOut);
        }
        showLoader(false);
    }

    const store = async (scan = undefined) => {
        scan = scan ?? state.scan
        const { filter } = state;
        const cond = validateForm('store', scan);

        if (cond) {
            showLoader(true);
            const response = await post('/paylocityScanner/store', { ...filter, ...scan });
            if (response.status === 200) {
                setState(prev => ({ ...prev, scans: response?.data ?? prev.scans, reportScans: response?.reportData ?? [], }));
                clear();

                showToast(response.message);
            } else {
                console.log('[Paylocity Scanner] store error', response);
                helpers.failRequest(response, showToast, signOut);
                showLoader(false);

                return false
            }
            showLoader(false);
        }

        return cond;
    }

    const update = async (idpaylocity_scanner = undefined, scan = undefined) => {
        idpaylocity_scanner = idpaylocity_scanner ?? state.scan.idpaylocity_scanner;
        scan = scan ?? state.scan
        const { filter } = state;
        const cond = validateForm('update', scan);

        if (cond) {
            showLoader(true);
            const response = await put(`/paylocityScanner/${idpaylocity_scanner}/update`, { ...filter, ...scan });
            if (response.status === 200) {
                setState(prev => ({ ...prev, scans: response?.data ?? prev.scans, reportScans: response?.reportData ?? [], }));
                showToast(response.message);
                showLoader(false);
                return true;
            } else {
                console.log('[Paylocity Scanner] update error', response);
                helpers.failRequest(response, showToast, signOut);
            }
            showLoader(false);
            return false
        }
        return false;
    }

    const destroy = async (scan = undefined) => {
        scan = scan ?? state.scan;
        const { idpaylocity_scanner } = scan;
        const cond = validateForm('delete', scan);

        if (cond) {
            showLoader(true);
            const response = await del(`/paylocityScanner/${idpaylocity_scanner}`, state.filter);
            if (response.status === 200) {
                setState(prev => ({ ...prev, scans: response?.data ?? prev.scans, reportScans: response?.reportData ?? [], }));
                clear();

                showToast(response.message);
            } else {
                console.log('[Paylocity Scanner] destroy error', response);
                helpers.failRequest(response, showToast, signOut);
            }
            showLoader(false);
        }
    }

    const search = async () => {
        showLoader(true);
        const response = await get('/paylocityScanner/search', state.filter);
        if (response.status === 200) {
            setState(prev => ({ ...prev, scans: response?.data, reportScans: response?.reportData ?? [], }));
            if (!response?.data[0]) showToast('There are no data with these filters', 'warning');
        } else {
            console.log('[Paylocity Scanner] search error', response);
            helpers.failRequest(response, showToast, signOut)
        }
        showLoader(false);
    }

    const reloadTime = () => {
        setState(prev => ({ ...prev, scan: { ...prev.scan, time: dayjs().tz(sede.time_zone).format('HH:mm') } }));
        showToast("Time updated")
    }

    const getName = ({ value }) => value?.name ?? 'N/A';
    const getNameOrCode = ({ value }) => value?.name ?? value?.code;
    const getTime = ({ row }) => dayjs(row.date + row.time).format('hh:mm A');
    const getDate = params => dayjs(params.value).format('MM/DD/YYYY');

    const getDateTime = params => params.value ? dayjs(params.value).format('YYYY-MM-DDTHH:mm:ss') : params.value;

    const renderCellScan = ({ row }) => {
        if (row.warning) {
            return (
                <Tooltip title="Update locally after upload, change in Paylocity" placement="top">
                    <Icon style={{ color: "red" }}>{"warning"}</Icon>
                </Tooltip>)
        }
        if (row.uploaded) {
            return (
                <Tooltip title="Uploaded to paylocity" placement="top">
                    <Icon style={{ color: "green" }}>{"check_circle"}</Icon>
                </Tooltip>)
        } else {
            return (
                <Tooltip title="Not uploaded" placement="top">
                    <Icon color='primary'>{"publish"}</Icon>
                </Tooltip>
            );
        }

    };

    const columns = [
        { field: 'idpaylocity_scanner', headerName: 'ID', flex: 0.25, minWidth: 85 },
        { field: 'uploaded', headerName: 'Paylocity', flex: 0.4, minWidth: 120, renderCell: renderCellScan },
        { field: 'user', headerName: 'Supervisor', flex: 0.7, minWidth: 90, valueGetter: getName },
        { field: 'employee', headerName: 'Employee', flex: 1.3, minWidth: 130, valueGetter: getName },
        { field: 'date', headerName: 'Date', flex: 0.6, minWidth: 80, valueGetter: getDate },
        { field: 'time', headerName: 'Time', flex: 0.6, minWidth: 70, valueGetter: getTime },
        { field: 'action', headerName: 'Action', flex: 0.7, minWidth: 70, valueGetter: getName },
        { field: 'clock_type', headerName: 'Type', flex: 0.6, minWidth: 90 },
        { field: 'cost_center', headerName: 'CC1', flex: 0.6, minWidth: 100, valueGetter: getNameOrCode },
        { field: 'cost_center_2', headerName: 'CC2', flex: 0.6, minWidth: 100, valueGetter: getNameOrCode },
        { field: 'cost_center_3', headerName: 'CC3', flex: 0.6, minWidth: 100, valueGetter: getNameOrCode },
    ];

    const renderCell = ({ row }) => {
        if (row.stop_time) {
            return (
                <IconButton disabled>
                    <Icon style={{ color: "green" }}>{"check"}</Icon>
                </IconButton>)
        } else {
            return (
                <IconButton disabled>
                    <Icon style={{ color: "orange" }}>{"warning"}</Icon>
                </IconButton>
            );
        }

    };

    const renderCellDelete = ({ row }) => {
        return (
            <IconButton onClick={e => destroy({ idpaylocity_scanner: row.idIn })}>
                <Icon style={{ color: "red" }}>{"delete"}</Icon>
            </IconButton>)
    };

    const columnsReport = [
        { field: 'idpaylocity_scanner', headerName: 'ID' },
        { field: 'custom', headerName: 'Status', renderCell },
        { field: 'user', headerName: 'Supervisor' },
        { field: 'code', headerName: 'Code' },
        { field: 'name', headerName: 'Name' },
        { field: 'action', headerName: 'Action', editable: true, type: 'singleSelect', valueOptions: state.selectionData.action },
        { field: 'start', headerName: 'Start', width: 180, editable: true, type: "dateTime", valueGetter: getDateTime },
        { field: 'stop', headerName: 'Stop', width: 180, editable: true, type: "dateTime", valueGetter: getDateTime },
        { field: 'hours', headerName: 'Hours' },
        { field: 'cc1', headerName: 'CC1', editable: true, type: 'singleSelect', valueOptions: state.selectionData.cc1 },
        { field: 'cc2', headerName: 'CC2', editable: true, type: 'singleSelect', valueOptions: state.selectionData.cc2 },
        { field: 'cc3', headerName: 'CC3', editable: true, type: 'singleSelect', valueOptions: state.selectionData.cc3 },
        { field: 'button', headerName: 'Action', renderCell: renderCellDelete },
    ];

    if (state.loading) {
        return <Loader />;
    }

    return (
        <>
            <Grid container>
                <Grid item sm={12} md={4}>
                    <FormGroup>
                        <FormLabel>{'Employee'}<span className={classes.requiredValue}>*</span></FormLabel>
                        <Autocomplete
                            options={state.employees}
                            value={state.scan.employee}
                            getOptionLabel={option => option?.name ?? ''}
                            getOptionSelected={(option, value) => option.id === value.id}
                            onChange={(e, value) => handleAutocomplete('employee', value)}
                            renderInput={params => <TextField {...params} placeholder='Employee' />}
                        />
                    </FormGroup>
                </Grid>
                <Grid item sm={12} md={4}>
                    <FormGroup>
                        <FormLabel>{'Action'}<span className={classes.requiredValue}>*</span></FormLabel>
                        <Autocomplete
                            options={state.actions}
                            value={state.scan.action}
                            getOptionLabel={option => option?.name ?? ''}
                            getOptionSelected={(option, value) => option.id === value.id}
                            onChange={(e, value) => handleAutocomplete('action', value)}
                            renderInput={params => <TextField {...params} placeholder='Action' />}
                        />
                    </FormGroup>
                </Grid>
                <Grid item sm={12} md={4}>
                    <FormGroup>
                        <FormLabel>{'Cost Center 2 (Cost)'}<span className={classes.requiredValue}>*</span></FormLabel>
                        <Autocomplete
                            options={state.costCenter2}
                            value={state.scan.cost_center_2}
                            getOptionLabel={option => option?.name ?? ''}
                            getOptionSelected={(option, value) => option.id === value.id}
                            onChange={(e, value) => handleAutocomplete('cost_center_2', value)}
                            renderInput={params => <TextField {...params} placeholder='Cost Center 2' />}
                        />
                    </FormGroup>
                </Grid>
                <Grid item sm={12} md={4}>
                    <FormGroup>
                        <FormLabel>{'Cost Center 3 (Team)'}<span className={classes.requiredValue}>*</span></FormLabel>
                        <Autocomplete
                            options={state.costCenter3}
                            value={state.scan.cost_center_3}
                            getOptionLabel={option => option?.name ?? ''}
                            getOptionSelected={(option, value) => option.id === value.id}
                            onChange={(e, value) => handleAutocomplete('cost_center_3', value)}
                            renderInput={params => <TextField {...params} placeholder='Cost Center 3' />}
                        />
                    </FormGroup>
                </Grid>
                <Grid item sm={12} md={3}>
                    <FormGroup>
                        <FormLabel>{'Date'}<span className={classes.requiredValue}>*</span></FormLabel>
                        <FormControl
                            variant='filled'
                            component={Box}
                            width='100%'
                        >
                            <FilledInput
                                autoComplete='off'
                                type='date'
                                placeholder='Date'
                                name='date'
                                value={state.scan.date}
                                onChange={handleChange}
                            />
                        </FormControl>
                    </FormGroup>
                </Grid>
                <Grid item sm={12} md={3}>
                    <FormGroup>
                        <FormLabel>{'Time'}<span className={classes.requiredValue}>*</span></FormLabel>
                        <FormControl
                            variant='filled'
                            component={Box}
                            width='100%'
                        >
                            <FilledInput
                                autoComplete='off'
                                type='time'
                                placeholder='Time'
                                name='time'
                                startAdornment={
                                    <InputAdornment position="start">
                                        <Tooltip title="Set actual time">
                                            <IconButton
                                                aria-label="Set actual time"
                                                onClick={reloadTime}
                                                edge="start"
                                            >
                                                <Icon>{'replay'}</Icon>
                                            </IconButton>
                                        </Tooltip>
                                    </InputAdornment>
                                }
                                value={state.scan?.time ?? dayjs().tz(sede.time_zone).format('HH:mm')}
                                onChange={handleChange}
                            />
                        </FormControl>
                    </FormGroup>
                </Grid>
                <Grid item sm={12} md={2}>
                    <FormGroup>
                        <FormLabel>Clock<span className={classes.requiredValue}>*</span></FormLabel>
                        <RadioGroup row name="radioClock" value={state.scan.clock_type} onChange={e => setState(prev => ({ ...prev, scan: { ...prev.scan, clock_type: e.target.value } }))}>
                            <FormControlLabel disabled={state.scan.idpaylocity_scanner !== 0} value="In" control={<Radio disableRipple color='black' />} label="In" />
                            <FormControlLabel disabled={state.scan.idpaylocity_scanner !== 0} value="Out" control={<Radio disableRipple color='black' />} label="Out" />
                        </RadioGroup>
                    </FormGroup>
                </Grid>
            </Grid>

            <Crud
                permissions={state.permissions}
                create={{ create: clear, store }}
                update={update}
                destroy={destroy}
                cancel={clear}
            />

            <Divider />

            <div className={classes.row}>
                <h2>{'Filters and Report'}</h2>
                <IconButton onClick={() => setShowFilters(!showFilters)}>
                    <Icon>{showFilters ? 'expand_less' : 'expand_more'}</Icon>
                </IconButton>
            </div>
            <Collapse in={showFilters}>
                <Grid container>
                    <Grid item sm={12} md={6}>
                        <FormGroup onClick={handleModal}>
                            <FormLabel>{'Date range'}</FormLabel>
                            <FormControl
                                variant='filled'
                                component={Box}
                                width='100%'
                            >
                                <FilledInput
                                    readOnly
                                    type='text'
                                    placeholder='Date range'
                                    value={state.filter.dateRange}
                                />
                            </FormControl>
                        </FormGroup>
                    </Grid>
                    <Grid item sm={12} md={6}>
                        <FormGroup>
                            <FormLabel>{'Employee'}</FormLabel>
                            <Autocomplete
                                options={state.employees}
                                value={state.filter.employeef}
                                getOptionLabel={option => option?.name ?? ''}
                                getOptionSelected={(option, value) => option.id === value.id}
                                onChange={(e, value) => handleAutocompleteFilter('employeef', value)}
                                renderInput={params => <TextField {...params} placeholder='Employee' />}
                            />
                        </FormGroup>
                    </Grid>
                    <Grid item sm={12} md={4}>
                        <FormGroup>
                            <FormLabel>{'Cost Center 2 (Cost)'}</FormLabel>
                            <Autocomplete
                                options={state.costCenter2}
                                value={state.filter.costCenter2f}
                                getOptionLabel={option => option?.name ?? ''}
                                getOptionSelected={(option, value) => option.id === value.id}
                                onChange={(e, value) => handleAutocompleteFilter('costCenter2f', value)}
                                renderInput={params => <TextField {...params} placeholder='Cost Center 2' />}
                            />
                        </FormGroup>
                    </Grid>
                    <Grid item sm={12} md={4}>
                        <FormGroup>
                            <FormLabel>{'Cost Center 3 (Team)'}</FormLabel>
                            <Autocomplete
                                options={state.costCenter3}
                                value={state.filter.costCenter3f}
                                getOptionLabel={option => option?.name ?? ''}
                                getOptionSelected={(option, value) => option.id === value.id}
                                onChange={(e, value) => handleAutocompleteFilter('costCenter3f', value)}
                                renderInput={params => <TextField {...params} placeholder='Cost Center 3' />}
                            />
                        </FormGroup>
                    </Grid>
                    <Grid item sm={12} md={4}>
                        <FormGroup>
                            <FormLabel>{'Action'}</FormLabel>
                            <Autocomplete
                                options={state.actions}
                                value={state.filter.actionf}
                                getOptionLabel={option => option?.name ?? ''}
                                getOptionSelected={(option, value) => option.id === value.id}
                                onChange={(e, value) => handleAutocompleteFilter('actionf', value)}
                                renderInput={params => <TextField {...params} placeholder='Action' />}
                            />
                        </FormGroup>
                    </Grid>
                </Grid>

                <div className={classes.buttonsContainer}>
                    <Button
                        variant='contained'
                        color='secondary'
                        onClick={clearFilters}
                    >
                        {"Clear"}
                    </Button>
                    <Button
                        variant='contained'
                        className={classes.report}
                        onClick={search}
                    >
                        {'Search'}
                    </Button>
                </div>
            </Collapse>

            <div className={classes.root}>
                <AppBar position="static" color="default">
                    <Tabs value={tabValue} onChange={(e, newValue) => setTabValue(newValue)}
                        variant="fullWidth"
                        indicatorColor="primary"
                        textColor="primary"
                        aria-label="Show data">
                        <Tab label="Scans Data" {...a11yProps(0)} />
                        <Tab label="Report Data" {...a11yProps(1)} />
                    </Tabs>
                </AppBar>
                <TabPanel value={tabValue} index={0}>
                    <Button variant="contained" className={classes.upload} disabled={state.selectedScanRows.length === 0} onClick={uploadPaylocitydata}>
                        {"Upload data to Paylocity"}
                    </Button>
                    <div className={classes.tableContainer}>
                        <DataGrid
                            rows={state.scans}
                            columns={columns}
                            pageSize={45}
                            density='compact'
                            autoHeight
                            getRowId={row => row.idpaylocity_scanner}
                            checkboxSelection
                            disableSelectionOnClick
                            onSelectionModelChange={handleSelectionRows}
                            onRowClick={({ row }) => setState(prev => ({ ...prev, scan: { ...row } }))}
                        />
                    </div>
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                    <FormControlLabel
                        control={<Switch checked={showErrorReport} onChange={handleSwitchChange} className={classes.switch} />
                        }
                        label={`Show ${state.reportError} unclosed task`}
                    />
                    {(state.reportScans.length === 0) && (
                        <Button variant="contained" className={classes.download} disabled>
                            {"Download data"}
                        </Button>
                    )}
                    {(state.reportScans.length > 0) && (
                        <ExcelFile
                            filename={`${dayjs().format("YYYY-MM-DD")}-scanner-report`}
                            element={
                                <Button variant="contained" className={classes.download} disabled={state.reportScans.length === 0}>
                                    {"Download data"}
                                </Button>

                            }
                        >
                            <ExcelSheet data={state.reportScans} name="Scans">
                                <ExcelColumn label="Scanner" value="user" />
                                <ExcelColumn label="Code" value="code" />
                                <ExcelColumn label="Name" value="name" />
                                <ExcelColumn label="Day" value="day" />
                                <ExcelColumn label="Action" value="action" />
                                <ExcelColumn label="Start Date" value="start_date" />
                                <ExcelColumn label="Start" value="start_time" />
                                <ExcelColumn label="Stop Date" value="stop_date" />
                                <ExcelColumn label="Stop" value="stop_time" />
                                <ExcelColumn label="CC1" value="cc1" />
                                <ExcelColumn label="CC2" value="cc2" />
                                <ExcelColumn label="CC3" value="cc3" />
                                <ExcelColumn label="Hours" value="hours" />
                            </ExcelSheet>
                        </ExcelFile>
                    )}
                    <div className={classes.tableContainer} style={{ display: 'flex', flexDirection: 'column' }}>
                        <DataGrid
                            rows={state.filteredReportScans}
                            columns={columnsReport}
                            pageSize={45}
                            onCellEditStart={handleStartEdit}
                            onCellEditCommit={handleCommitEdit}
                            density='compact'
                            autoHeight
                            getRowId={row => row.idpaylocity_scanner_block}
                        />
                    </div>
                </TabPanel>
            </div>

            <DateRange
                open={state.rangeModal.open}
                range={state.rangeModal.range}
                onClose={handleModal}
                onChange={handleDateChange}
                minDate={dayjs('2022-01-01').toDate()}
            />
        </>
    );
}

export default ScannerPaylocityDesktop;